// extracted by mini-css-extract-plugin
module.exports = {"Error500Toast":"styles_Error500Toast__fuC6b"};